import { jsonToMultilineString } from 'legacy-src/utility/helpers';
import {
  assignmentDueDate,
  assignmentStartDate,
  getRelatedAssignmentDueAtDate,
} from 'legacy-src/utility/assignmentDates';
import { get } from 'lodash';
import { sortFinalExamAssignments } from 'legacy/src/components/assignment/Assignment/components/FinalExamTabs';
import { getSubGroupStudentsLabel } from 'legacy-src/utility/utils';
import buildSubgroupStudents from 'chameleon/ui-stack/utilities/utils/buildSubgroupStudents';
/**
 * Returns a multiline string with the copyable details of an assignment.
 * @param {object} assignment - The assignment object to destructure.
 * @param {string} subject - The subject ID.
 * @param {boolean} isFinalExam - Flag for final exams (PREAP Only).
 * @return {string} - The multiline string with the details of an assignment to be copied.
 * */
export default (
  assignment,
  subject,
  isFinalExam = false,
  studentsBySection = {},
  isSPP = false,
) => {
  const {
    id,
    assignment_id,
    section,
    title,
    assignees,
    section_name,
    print_toggle: isOffline,
    subGroupStudents,
    sub_group_students,
  } = assignment;
  const studentTeacherCommonURL = `${FYM_FRONTEND_URL}/${subject}/`;
  const className =
    section_name || section || (assignees && assignees[0] && assignees[0].name);
  const subGroupStudentsLabel = getSubGroupStudentsLabel(
    buildSubgroupStudents(
      subGroupStudents || sub_group_students,
      studentsBySection,
    ),
  );

  let detailsToBeCopiedJSON = {
    Assignment: title || get(assignment, 'assignment.title'),
    Class: className + subGroupStudentsLabel,
  };

  if (!isOffline) {
    const startsAt = assignmentStartDate(assignment, 'dateAndTimeZoned', null);
    const dueAt = assignmentDueDate(assignment, 'dateAndTimeZoned', null);

    if (startsAt) {
      detailsToBeCopiedJSON['Available as of'] = startsAt;
    }

    if (dueAt) {
      detailsToBeCopiedJSON.Due = dueAt;
    }
  }
  const assignmentId = id || assignment_id;
  const relatedAssignments =
    assignment.relatedAssignments || assignment.related_assignments;
  const studentAssignmentPath = isSPP
    ? 'assessments/spp/'
    : 'assessments/assignments/';
  const studentAssignmentLabel = isSPP
    ? 'Link for students to take assignment'
    : 'Link for students to take test';
  if (isFinalExam && relatedAssignments && relatedAssignments.length) {
    // Get part one of the final exam.
    let assignmentArr = [...relatedAssignments, assignment];
    assignmentArr = sortFinalExamAssignments(assignmentArr);

    // Use session 2 Due at attribute
    const firstPart = assignmentArr.shift();
    const lastPart = assignmentArr.pop();

    //  Use assessmentGroup name
    if (assignment.assessment_group) {
      detailsToBeCopiedJSON.Assignment = assignment.assessment_group.name;
    }
    const startsAt = assignmentStartDate(firstPart, 'dateAndTimeZoned', null);
    if (startsAt) {
      detailsToBeCopiedJSON['Available as of'] = startsAt;
    }

    // Use session 2 Due at attribute
    lastPart.starts_at = lastPart.starts_at || lastPart.startsAt;
    lastPart.due_at = getRelatedAssignmentDueAtDate(lastPart);
    const dueAt = assignmentDueDate(lastPart, 'dateAndTimeZoned', null);
    if (dueAt) {
      detailsToBeCopiedJSON.Due = dueAt;
    }

    detailsToBeCopiedJSON = {
      ...detailsToBeCopiedJSON,
      'Session 1 link for students to take test': `${studentTeacherCommonURL}assessments/assignments/${firstPart.id}`,
      'Session 2 link for students to take test': `${studentTeacherCommonURL}assessments/assignments/${lastPart.id}`,
      'Link for teachers to track progress': `${studentTeacherCommonURL}assignments/progress/${firstPart.id}`,
    };
  } else {
    detailsToBeCopiedJSON = {
      ...detailsToBeCopiedJSON,
      [`${studentAssignmentLabel}`]: `${studentTeacherCommonURL}${studentAssignmentPath}${assignmentId}`,
      'Link for teachers to track progress': `${studentTeacherCommonURL}assignments/progress/${assignmentId}`,
    };
  }

  return jsonToMultilineString(detailsToBeCopiedJSON, 2);
};
